<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Coupons" :submit="submit"
    :status="status" :breadcrumbs="[
      {
        text: 'Marketing y comunicación',
        disabled: false,
        href: '/admin/coupons',
      },
      {
        text: '...',
        disabled: false,
        href: '#',
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: false,
        href: '#',
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="title" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Título</div>
                <v-text-field solo hide-details="auto" class="input-base" :error-messages="errors" v-model="data.title"
                  label="Título"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="code" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Código</div>
                <v-text-field solo hide-details="auto" class="input-base" :error-messages="errors" v-model="data.code"
                  label="Código"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="type" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tipo</div>
                <v-select append-icon="$caretDownFormIcon" solo hide-details="auto" class="input-base"
                  :error-messages="errors" v-model="data.type" label="Tipo" :items="types">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">

              <v-menu ref="menu_dead_line" v-model="menu_expire_date" :close-on-content-click="false"
                transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on, attrs }">
                  <ValidationProvider ref="expire_date" rules="required" v-slot="{ errors }">
                    <div class="label-base pb-1">Fecha de expiración</div>
                    <v-text-field solo hide-details="auto" class="input-base" v-model="data.expire_date"
                      label="Fecha de expiración" prepend-inner-icon="fas fa-calendar" readonly v-bind="attrs" v-on="on"
                      :error-messages="errors"></v-text-field>
                  </ValidationProvider>
                </template>
                <v-date-picker v-model="expire_date" label="Project Duration" type="date" no-title scrollable
                  @change="menu_expire_date = false"></v-date-picker>
              </v-menu>

            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>

            <v-col class="py-0 px-2">
              <ValidationProvider ref="discount_percentage" :rules="rules_discount_percentage" v-slot="{ errors }">
                <div class="label-base pb-1">Porcentaje de descuento</div>
                <v-text-field solo hide-details="auto" class="input-base" :error-messages="errors"
                  v-model.number="data.discount_percentage" type="Number" min="1"
                  label="Porcentaje de descuento"></v-text-field>
              </ValidationProvider>
            </v-col>

            <v-col class="py-0 px-2">
              <ValidationProvider ref="fee_minutes" :rules="rules_fee_minutes" v-slot="{ errors }">
                <div class="label-base pb-1">Minutos gratis</div>
                <v-text-field solo hide-details="auto" class="input-base" :error-messages="errors"
                  v-model.number="data.fee_minutes" type="Number" min="1" label="Minutos gratis"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="stock" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Stock</div>
                <v-text-field solo hide-details="auto" class="input-base" :error-messages="errors"
                  v-model.number="data.stock" type="Number" label="Stock"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Descripción</div>
                <v-textarea :error-messages="errors" v-model="data.description" label="Descripción" solo
                  placeholder="Descripción" hide-details="auto" class="text-tarea-base" rows="8"></v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters v-if="show_list">
            <v-col class="py-0 px-2">
              <label for="Usuarios">Usuarios</label>
              <p>
                <span v-for="full_name, key of show_users">
                  {{ key > 0 ? `,${full_name}` : `${full_name}` }}
                </span>
              </p>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters v-else>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="status" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Usuarios</div>
                <v-select append-icon="$caretDownFormIcon" solo hide-details="auto" class="input-base"
                  :error-messages="errors" v-model="data.users" label="Usuarios" :items="usersCopy" item-value="id"
                  :item-text="(row) => `${row.name || ''} ${row.last_name || ''}`" multiple search-input>
                  <template #prepend-item>

                    <v-list-item>
                      <v-list-item-content>
                        <v-text-field solo hide-details="auto" class="input-base" v-model="searchUser"
                          placeholder="Search" @input="searchUsers"></v-text-field>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider class="mt-2"></v-divider>

                    <v-list-item>
                      <v-list-item-action>
                        <v-checkbox v-model="selectAll" :indeterminate="selectAll === null" :input-value="false"
                          class="input-check-base mt-5" hide-details="auto" on-icon="$checkedIcon"
                          off-icon="$unCheckedIcon" @click="clickSelectAll(selectAll)"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>Seleccionar todos</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                  </template>
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col class="py-0 px-2">
              <div class="label-base pb-1"></div>
              <v-checkbox v-model="data.coupon_for_new_user" label="Cupón para nuevo usuario"
                class="input-check-base mt-5" hide-details="auto" on-icon="$checkedIcon"
                off-icon="$unCheckedIcon"></v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

extend('numberpositivo', {
  validate: value => {
    return value > 0;
  },
  message: 'El campo debe ser mayor a 0.'
});

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  async created() {
    const self = this;

    await this.$store.dispatch("Users/getListAll", { show_all: 'enable', sorting_column: 'name', sorting_order: 'asc' })
    this.usersCopy = this.users;

    if (this.$route.params.id) {
      await self.$store
        .dispatch("Coupons/show", this.$route.params.id)
        .then((val) => {
          this.show_users = val.user_coupons.map(user_coupon => `${user_coupon.user_id.name || ''} ${user_coupon.user_id.last_name || ''}`);
        });
      this.show_list = true;
    }
  },
  beforeDestroy() {
    this.$store.dispatch("Users/clearList");
  },
  data() {
    return {
      storeName: "Coupons",
      title: "Cupon",
      data: {
        title: '',
        description: '',
        code: '',
        discount_percentage: '',
        expire_date: '',
        type: '',
        fee_minutes: '',
        users: [],
        stock: 0,
        coupon_for_new_user: '',
      },
      types: ['discount', 'free_minutes'],
      expire_date: '',
      menu_expire_date: false,
      selectAll: false,
      searchUser: '',
      usersCopy: [],
      show_list: false,
      show_users: [],
    };
  },
  computed: {
    ...mapState({
      status: state => state.Coupons.status,
      users: state => state.Users.list
    }),
    rules_discount_percentage() {
      const rules = ['numberpositivo'];
      if (this.data.type == 'discount') {
        rules.push('required');
      }
      return rules.join('|');
    },
    rules_fee_minutes() {
      const rules = ['numberpositivo'];
      if (this.data.type == 'free_minutes') {
        rules.push('required');
      }
      return rules.join('|');
    },
  },
  watch: {
    expire_date(val) {
      this.expire_date = val;
      this.data.expire_date = this.formatDateForSave(val);
    },
    'data.users'(newValue) {
      if (newValue.length === this.usersCopy.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
    },
  },
  methods: {
    clickSelectAll(value) {
      if (value) {
        this.data.users = this.usersCopy.map(user => user.id);
      } else {
        this.data.users = [];
      }
    },
    searchUsers() {
      if (!this.searchUser) {
        this.usersCopy = this.users;
      }

      this.usersCopy = this.users.filter(user => {
        let full_name = `${user.name || ''} ${user.last_name || ''}`;
        return full_name.toLowerCase().indexOf(this.searchUser.toLowerCase()) > -1
      })
    }

  },
}
</script>
